import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { observer } from 'mobx-react'
import Link from 'next/link'
import ArrowDownLineSvg from '../../../public/images/common/home/2508/arrow-down-line.svg'
import styles from './index.module.scss'

type ServiceCard = {
  title: string
  description: string
  imageUrl: string
  linkUrl: string
  imageWidthMd: string
  imageWidthLg: string
  imagePosition?: 'center' | 'right'
}

export const TopPageForInvestors2508: FC = observer(() => {
  const { t } = useTranslation(['index'])
  const [isMobileClient, setIsMobileClient] = useState(false)

  useEffect(() => {
    const mobileBreakpoint = 1092
    const handleResize = () => {
      if (typeof window === 'undefined') {
        return
      }
      setIsMobileClient(window.innerWidth < mobileBreakpoint)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const services: ServiceCard[] = [
    {
      title: t('topPage2508.investors.services.startupMatching.title'),
      description: t('topPage2508.investors.services.startupMatching.description'),
      imageUrl: '/images/common/home/2508/マッチング.png',
      linkUrl: '/startups',
      imageWidthMd: '246px',
      imageWidthLg: '100%',
    },
    {
      title: t('topPage2508.investors.services.investmentCloud.title'),
      description: t('topPage2508.investors.services.investmentCloud.description'),
      imageUrl: '/images/common/home/2508/投資管理クラウド.png',
      linkUrl: 'https://prosupporters.protocol.ooo/investorcloud',
      imageWidthMd: '256px',
      imageWidthLg: '286px',
    },
    {
      title: t('topPage2508.investors.services.reverseOffer.title'),
      description: t('topPage2508.investors.services.reverseOffer.description'),
      imageUrl: '/images/common/home/2508/逆オファー.png',
      linkUrl: 'https://toshika-lp.protocol.ooo/toshika-investor-partners',
      imageWidthMd: '233px',
      imageWidthLg: '257px',
    },
  ]

  const renderServiceCard = (service: ServiceCard) => {
    const cardButton = (
      <span className={styles.cardButton}>
        <span>{t('topPage2508.common.detailButton')}</span>
        <ArrowDownLineSvg />
      </span>
    )

    const card = (
      <div className={`${styles.serviceCard}`}>
        <div className={styles.cardInner}>
          <div className={styles.cardTexts}>
            <h3 className={styles.cardTitle}>{service.title}</h3>
            <p className={styles.cardDescription}>{service.description}</p>
            {isMobileClient && cardButton}
          </div>
          <div
            className={`${styles.cardImageWrap} ${
              service.imagePosition === 'right' ||
              (service.title === t('topPage2508.investors.services.startupMatching.title') && isMobileClient)
                ? styles.cardImageWrapRight
                : ''
            }`}
            style={{ width: isMobileClient ? service.imageWidthMd : service.imageWidthLg }}
          >
            <img src={service.imageUrl} alt={service.title} />
          </div>
          {!isMobileClient && cardButton}
        </div>
      </div>
    )

    if (service.linkUrl.startsWith('http')) {
      return (
        <a
          key={service.title}
          href={service.linkUrl}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.cardLink}
        >
          {card}
        </a>
      )
    }

    return (
      <Link key={service.title} href={service.linkUrl}>
        <a className={styles.cardLink}>{card}</a>
      </Link>
    )
  }

  return (
    <div className={styles.container}>
      <div className='container'>
        <div className={styles.header}>
          <h1 className={styles.mainTitle}>{t('topPage2508.investors.sectionTitle')}</h1>
          <p className={styles.subtitle}>{t('topPage2508.investors.sectionSubtitle')}</p>
        </div>

        <div className={styles.mainBox}>
          <div className={styles.categoryGrid}>{services.map(renderServiceCard)}</div>
        </div>
      </div>
    </div>
  )
})
